function getPolygonPath(polygon){
    let keys = Object.keys(polygon.state.polygon.latLngs);
    for(let key of keys){
        if(Array.isArray(polygon.state.polygon.latLngs[key])){
            let coordinates = polygon.state.polygon.latLngs[key][0][key].map(point => {
                return [point.lng(), point.lat()];
            });
            // SI el punto inicial es diferente al punto final
            if (
                coordinates[0][0] !== coordinates[coordinates.length - 1][0] &&
                coordinates[0][1] !== coordinates[coordinates.length - 1][1]
            ){
                // Agregar el punto inicial al final (para cerrar el poligono)
                coordinates.push(coordinates[0]);
            }
            return coordinates;
        }
        break;
    }
    return false;
}

export {
    getPolygonPath
};
